import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PatientService {
  private ApiUrl = "";

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.ApiUrl = baseUrl;
  }

  getPatients(pharmacyId, facilityId, userId: string, status: boolean, lastName, firstName): Observable<any[]> {
    if (lastName == "")
      lastName = " ";

    return this.http.get<any[]>(this.ApiUrl + 'api/Integration/GetPatients/' + pharmacyId + '/' + facilityId + '/' + userId + '/' + status + '/' + lastName + '/' + firstName);
  }

  getPatientDtos(pharmacyId, facilityId, userId: string, status): Observable<any[]> {
    return this.http.get<any[]>(this.ApiUrl + 'api/Integration/GetPatientDtos/' + pharmacyId + '/' + facilityId + '/' + userId + '/' + status);
  }

  getPatientsByDoctorUserId(pharmacyId, facilityId, userId: string, status, doctorUserId: string): Observable<any[]> {
    return this.http.get<any[]>(this.ApiUrl + 'api/Integration/GetPatientsByDoctorUserId/' + pharmacyId + '/' + facilityId + '/' + userId + '/' + status + '/' + doctorUserId);
  }

  getPatient(pharmacyId, patientId): Observable<any> {
    return this.http.get<any>(this.ApiUrl + 'api/Integration/GetPatientDto/' + pharmacyId + '/' + patientId);
  }

  getPrescriptionDtos(pharmacyId, patientId): Observable<any[]> {
    return this.http.get<any[]>(this.ApiUrl + 'api/Integration/GetPrescriptionDtos/' + pharmacyId + '/' + patientId);
  }

  createPatient(patientProfileDto): Observable<any> {
    const headers = { 'content-type': 'application/json' };
    const url = this.ApiUrl + 'api/Patient/CreatePatient';
    return this.http.post<any>(url, patientProfileDto, { 'headers': headers });
  }

  getPatientDtosByFacilityRetail(pharmacyId): Observable<any[]> {
    return this.http.get<any>(this.ApiUrl + 'api/Patient/getPatientDtosByFacilityRetail/' + pharmacyId);
  }

  getPatientProfileImageSettings(): Observable<{ hashInputSalt: string; fileservicePatientsBaseUrl: string }> {
    return this.http.get<{ hashInputSalt: string; fileservicePatientsBaseUrl: string }>(
      this.ApiUrl + 'api/Patient/GetPatientProfileImageSettings');
  }

  getPatientDtosList(
    pharmacyId?: number,
    facilityId?: number,
    search?: string,
    page: number = 1,
    pageSize: number = 50,
    activeOnly: boolean = true
  ): Observable<any> {
    var params = new HttpParams()
      .set('page', page.toString())
      .set('pageSize', (pageSize != null && pageSize > 0 ? pageSize : 50).toString())
      .set('activeOnly', activeOnly ? 'true' : 'false');
    if (pharmacyId != null && pharmacyId > 0) {
      params = params.set('pharmacyId', pharmacyId.toString());
    }
    if (facilityId != null && facilityId > 0) {
      params = params.set('facilityId', facilityId.toString());
    }
    if (search != null && search.trim() !== '') {
      params = params.set('search', search.trim());
    }
    return this.http.get<any>(this.ApiUrl + 'api/Patient/GetPatientDtosList', { params: params });
  }
}
